export default __webpack_public_path__ + "static/media/Merchology-motion-graphic-cropped.04780592.gif";